<template>
    <div>
        <div style="" class="d-flex justify-content-left  leftTitle mt-2 clearfix ">
            <li><span class="otherInfo"></span>{{$t("otherInfo.1")}}:</li>
        </div>
        <div style="" class="mt-2 clearfix">
            <div class="otherInfoLeft  "><span class="birth"></span>{{$t("otherInfo.2")}}:</div>
            <div class="otherInfoLeft bold "><span class="birthDate">30.11.1969</span></div>
        </div>
        <div style="" class="mt-1 clearfix">
            <div class="otherInfoLeft  "><span class="age"></span>{{$t("otherInfo.3")}}:</div>
            <div class="otherInfoLeft bold "><span class="ageNumber">{{age}} {{$t("otherInfo.4")}}</span></div>
        </div>
        <div style="" class="mt-1 clearfix">
            <div class="otherInfoLeft  "><span class="national"></span>{{$t("otherInfo.5")}}:</div>
            <div class="otherInfoLeft bold "><span class="nationalName">{{$t("otherInfo.6")}}</span></div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                age: 54,
            }
        },
        methods: {
            getAge() {
                let birthDay = new Date("November 30, 1969 21:00:00")
                let now = new Date();
                
                let diff =(now.getTime() - birthDay.getTime()) / 1000
                diff = diff / (60 * 60 * 24);

                this.age = Math.abs(Math.round(diff/365.25)) - 1
            }
        },
        mounted () {
            //this.getAge()
        },                
    }
</script>

<style lang="scss" scoped>

</style>